import React, { useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import { useAuth } from "../utility/auth";
import {
  Container,
  Grid,
  useTheme,
  Box,
  Stack,
  IconButton,
} from "@mui/material";
import * as Yup from "yup";
import Load from "../components/FormsUI/Loader/index";
import Controls from "../components/FormsUI";
import CustomizedSnackbars from "../components/Alert";
import MemberShipController from "../controller/MemberShipController";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import EXCEL_ICON from "../assets/images/excel_icon.png";
import ExceptionHandlerController from "../controller/ErrorLogsController";
import excelPath from "../assets/Sample_Member_Excel_File/sample.xlsx";
import dayjs from "dayjs";
import moment from "moment";
import "../css/style.css";
import { tokens } from "../theme";
import { downloadPDF } from "../utility/downloadPDF";
var XLSX = require("xlsx");

const EXCEL_INITIALFORM = { excelFile: "" };
const FAMILYNAME_INITIALFORM = { familyName: "" };
const EXCEL_FORM_VALIDATION = Yup.object().shape({
  excelFile: Yup.string().required("Excel file Upload is required"),
});
const FAMILY_NAME_VALIDATION = Yup.object().shape({
  familyName: Yup.string()
    .required("Family Name is Required")
    .trim("No white space allowed")
    .strict(true)
    .matches(
      /^[A-Z a-z]+$/,
      "Family Name must contain only alphabetic characters"
    ),
});

const ADD_MEMBER_INITIAL_VALUES = {
  membershipNumber: "",
  memberFullName: "",
  gender: "",
  familyName: "",
  familyNameId: "",
  memberType: "",
  selectedMemberType: null,
  mobileNumber: "",
  emailID: "",
  address: "",
  state: "",
  city: "",
  country: "",
  dob: "",
  selectedDDgender: null,
  selectedDDfamilyName: null,
};
const ADD_MEMBER_VALIDATION_VALUES = Yup.object().shape({
  membershipNumber: Yup.string()
    .required("Membership number is required")
    .trim("White space is not allowed")
    .strict(true)
    .max(100, "Membership number should not excceed 100 character"),
  memberFullName: Yup.string()
    .required("Member full name is required")
    .trim("White space is not allowed")
    .strict(true)
    .matches(
      /^[A-Z a-z]+$/,
      "MemberFull name must contain only alphabetic characters"
    )
    .max(100, "Member full name should not excceed 100 character"),
  gender: Yup.string()
    .required("Gender is required")
    .oneOf(
      ["Male", "Female", "Transgender"],
      "Gender must be either Male, Female, or Transgender"
    ),

  familyName: Yup.string()
    .required("Family name is required")
    .test(
      "no-add-family",
      "Family Name is required",
      (value) => value !== "Add Family"
    ),
  familyNameId: Yup.string().optional().trim(true),
  memberType: Yup.string().required("Member type is required"),
  mobileNumber: Yup.string()
    .required("Mobile no is required")
    .trim("White space is not allowed")
    .strict(true)
    .max(10, "Mobile no should not excceed 10 character"),
  emailID: Yup.string()
    .optional()
    .max(100, "Email-id should not excceed 100 character")
    .trim("White space is not allowed")
    .strict(true),
  dob: Yup.string().required("Date of birth is required"),
  address: Yup.string()
    .optional()
    .trim("White space is not allowed")
    .strict(true)
    .max(150, "Address should not excceed 100 character"),
  state: Yup.string().when("address", {
    is: (address) => address && address.trim() !== "",
    then: Yup.string()
      .required("State is required")
      .trim("White space is not allowed")
      .strict(true)
      .max(100, "State should not excceed 100 character"),
    otherwise: Yup.string().optional(),
  }),
  city: Yup.string().when("address", {
    is: (address) => address && address.trim() !== "",
    then: Yup.string()
      .required("City is required")
      .trim("White space is not allowed")
      .strict(true)
      .max(100, "City should not excceed 100 character"),
    otherwise: Yup.string().optional(),
  }),
  country: Yup.string().when("address", {
    is: (address) => address && address.trim() !== "",
    then: Yup.string()
      .required("Country is required")
      .trim("White space is not allowed")
      .strict(true)
      .max(100, "Country should not excceed 100 character"),
    otherwise: Yup.string().optional(),
  }),
});

const MemberShip = () => {
  const theme = useTheme();
  const auth = useAuth();
  const user = auth.decoder(sessionStorage.getItem("user"));
  const { data, token } = user;
  const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
  const [sectionGrid, setSectionGrid] = useState([]);
  const [loader, setLoader] = useState(false);
  const [updatedValues, setUpdatedValues] = useState(ADD_MEMBER_INITIAL_VALUES);
  const [IP, setIP] = useState("");
  const [memberID, setMemberID] = useState("");
  const [isDropdown, setIsDropdown] = useState(false);
  const [familyNameDD, setFamilyNameDD] = useState([]);
  const [clientDataXLSX, setClientDataXLSX] = React.useState();
  const [fileExcel, setFileExcel] = React.useState();
  const [genderData, setGenderData] = React.useState(null);
  const [memberTypeData, setMemberTypeData] = React.useState(null);

  const memberShipController = new MemberShipController();
  const exceptionHandlerController = new ExceptionHandlerController();
  // const { userid: tenantId } = data.UserInfo;
  const { userid: userId, tenantid: tenantId } = data.UserInfo;
  const colors = tokens(theme.palette.mode);
  const [popup, setPopUp] = useState(false);
  const [popup1, setPopUp1] = useState(false);
  const [popup2, setPopUp2] = useState(false);
  const [popup3, setPopUp3] = useState(false);

  let GenderDD = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Transgender", label: "Transgender" },
  ];
  const MemberShipData = [
    { label: "Primary Member", value: "Primary Member" },
    { label: "Family Member", value: "Family Member" },
    { label: "Leo Lion Member", value: "Leo Lion Member" },
  ];
  React.useEffect(() => {
    async function ipAddress() {
      await fetch("https://api.ipify.org/?format=json")
        .then((response) => response?.json())
        .then((IPData) => setIP(() => IPData?.ip))
        .catch((error) => console.error("error", error));
    }
    ipAddress();
  }, []);

  React.useEffect(() => {
    getSectionsGrid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };
  const saveFile = (e, setFieldValue, field) => {
    let caughtError;
    try {
      const fileSizeInBytes = e?.target?.files[0]?.size;
      const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
      if (fileSizeInMB > 4) {
        showAlert("error", "Document size should not exceed 4MB");
        return;
      }
      const allowedExtensions = [
        "xlsx",
        "xlam",
        "xml",
        "xls",
        "xlt",
        "xltm",
        "xltx",
        "xlsb",
        "xlsm",
      ];
      const fileName = e?.target?.files?.[0]?.name;
      const fileExtension = fileName?.split(".").pop()?.toLowerCase();

      if (field === "excelFile" && allowedExtensions.includes(fileExtension)) {
        setFileExcel(() => e?.target?.files?.[0]);
        setFieldValue("excelFile", e?.target?.files?.[0]);
      } else {
        showAlert("error", "Only Excel files (xlsx, xls) are allowed");
      }
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: "ResearchExcel saveFile method" };
      exceptionHandlerController.HandleException(logError);
    }
  };
  const handleAddFamilyName = (setFieldValue) => {
    setIsDropdown(false);
    resetFamilyNameFields(setFieldValue);
    handleData3();
  };

  const resetFamilyNameFields = (setFieldValue) => {
    setFieldValue("familyName", "");
    setFieldValue("selectedDDfamilyName", null);
  };

  const downloadExcel = () => {
    const filePath = excelPath;
    const downloadLink = document.createElement("a");
    downloadLink.href = filePath;
    downloadLink.download = "sample-file.xlsx";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const handleDobChange = (setFieldTouched, setFieldValue, e) => {
    const formatted = moment(new Date(e)).format("DD/MM/YYYY");
    setFieldTouched("dob", true);
    setFieldValue("dob", formatted);
  };

  const getExcelData = (fetchedExcelData) => {
    const workbook = XLSX.utils.book_new();
    const transformedData = fetchedExcelData.map((exceldata) => [
      exceldata.membershipNumber,
      exceldata.memberFullName,
      exceldata.gender,
      exceldata.familyName,
      exceldata.dob,
      exceldata.memberType,
      exceldata.mobileNumber,
      exceldata.emailID,
      exceldata.address,
      exceldata.city,
      exceldata.state,
      exceldata.country,
    ]);

    // Create a new worksheet with headers and transformed data
    const worksheet = XLSX.utils.aoa_to_sheet([
      [
        "MEMBERSHIP_NUMBER",
        "MEMBER_FULL_NAME",
        "GENDER(MALE/FEMALE/TRANSGENDER)",
        "FAMILY_NAME",
        "DATE_OF_BIRTH(DD/MM/YYY)",
        "MEMBERTYPE(PRIMARY_MEMBER/FAMILY_MEMBER/LEO_LION_MEMBER)",
        "MOBILE_NUMBER",
        "EMAILID",
        "ADDRESS",
        "CITY",
        "STATE_PROVINCE",
        "COUNTRY",
      ],
      ...transformedData,
    ]);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Members Details");
    // Generate a binary string from the workbook
    const excelData = XLSX.write(workbook, {
      type: "binary",
      bookType: "xlsx",
    });
    // Convert the binary string to a Blob
    const blob = new Blob([s2ab(excelData)], {
      type: "application/octet-stream",
    });
    setClientDataXLSX(blob);
  };
  function s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }
  const submitMemberValues = (values) => {
    values.IP = IP;
    let caughtError;
    const filteredData = {};
    for (let key in values) {
      if (
        values[key] !== "" &&
        !key.startsWith(":") &&
        typeof values[key] !== "object" &&
        values[key] !== null
      ) {
        filteredData[key] = values[key];
      }
    }
    try {
      filteredData.tenantId = tenantId;
      if (memberID) {
        filteredData.memberID = memberID;
        memberShipController
          .UpdateMember(filteredData, token)
          .then((resultObj) => {
            if (resultObj.status === 200) {
              setMemberID(resultObj?.data?.body?.memberId);
              getSectionsGrid();
              showAlert("success", resultObj?.data?.message);
            } else {
              showAlert("error", resultObj?.response?.data?.message);
            }
          });
      } else {
        memberShipController
          .CreateMember(filteredData, token)
          .then((resultObj) => {
            if (resultObj.status === 201) {
              setMemberID(resultObj?.data?.body?.memberId);
              getSectionsGrid();
              showAlert("success", resultObj?.data?.message);
            } else {
              showAlert("error", resultObj?.response?.data?.message);
            }
          });
      }
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "feeReceipt page submitValues method",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const columns = [
    { headerName: "Id", field: "memberId", hide: true, filterable: false },
    { headerName: "Membership Number", field: "membershipNumber", width: 200 },
    { headerName: "Member Name", field: "memberFullName", width: 180 },
    { headerName: "Email ID", field: "emailID", width: 200 },
    { headerName: "Mobile Number", field: "mobileNumber", width: 150 },
    { headerName: "Create Date", field: "createdDate", width: 130 },
    {
      field: "action",
      headerName: "Action",
      width: 180,
      sortable: false,
      disableExport: true,
      filterable: false,
      disableClickEventBubbling: true,
      renderCell: (params) => {
        const onClick = (e, type) => {
          let caughtError;
          try {
            setAlert({ counter: 0, type: "", msg: "" });
            const currentRow = params.row;
            if (type === "Edit") {
              setIsDropdown(false);
              setUpdatedValues();
              setMemberID();
              setLoader(() => true);
              let tempData = {};
              memberShipController
                .GetMemberById(currentRow.id, token)
                .then((resultObj) => {
                  setLoader(() => false);
                  const responseData = resultObj?.data?.body ?? {};
                  if (resultObj.status === 200) {
                    tempData = {
                      membershipNumber: responseData?.membershipNumber ?? "",
                      memberFullName: responseData?.memberFullName ?? "",
                      gender: responseData?.gender ?? "",
                      memberType: responseData?.memberType ?? "",
                      mobileNumber: responseData?.mobileNumber ?? "",
                      emailID: responseData?.emailID ?? "",
                      address: responseData?.address ?? "",
                      state: responseData?.state ?? "",
                      city: responseData?.city ?? "",
                      country: responseData?.country ?? "",
                      dob: responseData?.dob ?? "",
                      familyNameId: responseData?.familyNameId ?? "",
                      familyName: responseData?.familyName ?? "",
                    };
                    setMemberID(responseData?.memberId);
                    setUpdatedValues(tempData);
                    if (responseData?.gender) {
                      setGenderData({
                        label: responseData?.gender ?? "",
                        value: responseData?.gender ?? "",
                      });
                    }
                    if (responseData?.memberType) {
                      setMemberTypeData({
                        label: responseData?.memberType,
                        value: responseData?.memberType,
                      });
                    }
                  } else {
                    showAlert("error", resultObj?.response?.data?.message);
                  }
                });
              handleData();
            } else {
              memberShipController
                .DeleteMemberID(currentRow.id, token)
                .then((resultObj) => {
                  setLoader(() => false);
                  if (resultObj.status === 200) {
                    showAlert("success", resultObj?.data?.message);
                    getSectionsGrid();
                  } else {
                    showAlert("error", resultObj?.response?.data?.message);
                  }
                });
            }
          } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
              logData,
              module: "service page onClick(Edit) method",
            };
            exceptionHandlerController.HandleException(logError);
          }
        };

        return (
          <Stack direction="row" spacing={1}>
            <>
              <IconButton>
                <EditIcon
                  type="button"
                  color="primary"
                  id="Edit"
                  onClick={(e) => onClick(e, "Edit")}
                />
              </IconButton>
              <IconButton>
                <DeleteIcon
                  type="button"
                  color="primary"
                  id="Delete"
                  onClick={(e) => onClick(e, "Delete")}
                />
              </IconButton>
            </>
          </Stack>
        );
      },
    },
  ];

  const handlePopup = (value) => setPopUp(value);
  const handlePopup1 = (value) => setPopUp1(value);
  const handlePopup2 = (value) => setPopUp2(value);
  const handlePopup3 = (value) => setPopUp3(value);
  const handleData = () => setPopUp(true);
  const handleData2 = () => setPopUp2(true);
  const handleData1 = () => setPopUp1(true);
  const handleData3 = () => setPopUp3(true);

  const subFamilyName = (value) => {
    let caughtError;
    try {
      memberShipController.CreateFamilyName(value, token).then((resultObj) => {
        if (resultObj.status === 201) {
          setIsDropdown(false);
          showAlert("success", resultObj?.data?.message);
          handlePopup3(false);
        } else {
          showAlert("error", resultObj?.response?.data?.message);
        }
      });
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: "memberShip handleFamilyName method" };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const handleFamilyName = async (value) => {
    setIsDropdown(false);
    try {
      const resultObj = await memberShipController.GetFamilyName(value, token);

      if (resultObj.status === 200) {
        const familyName = resultObj?.data?.body || [];
        const fetchedFamilyNameDD = familyName
          .filter((item) => item?.familyName && item?.familyMemberId)
          .map((item) => ({
            label: item.familyName,
            value: item.familyMemberId,
          }));

        setFamilyNameDD(fetchedFamilyNameDD);
        setIsDropdown(true);
        return fetchedFamilyNameDD;
      } else {
        showAlert("error", resultObj?.response?.data?.message);
        return []; // Returning an empty array on error
      }
    } catch (error) {
      const logData = {
        message: error.message,
        stack: error.stack,
      };
      const logError = {
        logData,
        module: "memberShip handleFamilyName method",
      };
      exceptionHandlerController.HandleException(logError);
      return []; // Returning an empty array on exception
    }
  };

  const getSectionsGrid = () => {
    let caughtError;
    try {
      memberShipController
        .GetGridData(token)
        .then((resultObj) => {
          setLoader(() => false);
          if (resultObj.status === 200) {
            const userData = resultObj?.data?.body?.map((item) => {
              const { memberId: id, ...rest } = item;
              return { id, ...rest };
            });
            getExcelData(resultObj?.data?.body);
            setSectionGrid(() => userData);
          } else {
            showAlert("error", resultObj?.response?.data?.message);
          }
        })
        .catch((error) => {
          caughtError = error;
          let logData = {};
          logData.message = caughtError?.message;
          logData.stack = caughtError?.stack;
          let logError = {
            logData,
            module: "memberShip page inside getServiceGrid method",
          };
          exceptionHandlerController.HandleException(logError);
        });
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "memberShip page getServiceGrid method",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const subExcelFile = (excelValue) => {
    excelValue.IP = IP;
    let caughtError;
    try {
      const formData = new FormData();
      for (var key in excelValue) {
        if (key !== "excelFile") formData.append(key, excelValue[key]);
      }
      if (!fileExcel) showAlert("error", "Excel is Required.");

      if (fileExcel) formData.append("excelFile", excelValue.excelFile);

      memberShipController
        .CreateExcelData(formData, token)
        .then((response) => {
          getSectionsGrid();
          let dataResponse = response?.response?.data;
          if (response?.code === "ERR_NETWORK")
            showAlert(
              "error",
              "The file is in use or has been recently modified. Refresh and try again."
            );
          if (response?.response?.status === 422)
            showAlert("error", "API Validation error");
          else if (response?.status === 201)
            showAlert("success", response?.data?.message);
          else if (dataResponse?.status === 400)
            showAlert("error", dataResponse?.message);
          else if (dataResponse?.status === 500)
            showAlert("error", dataResponse?.message);
        })
        .catch((error) => showAlert("error", "Oops something went wrong."));
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: "subExcelFile Submit method" };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const AddContent = (e) => {
    setMemberID("");
    setIsDropdown(false);
    handleData1();
  };

  const UploadExcel = (e) => {
    handleData2();
  };

  const handleFieldChange = (setFieldValue, fieldName) => (event) => {
    setFieldValue(fieldName, event.target.value);
  };
  const handleSearch = (familyName) => {
    if (familyName) {
      handleFamilyName(familyName);
    } else {
      showAlert("error", "Please input the family name field");
    }
  };
  if (loader) return <Load />;
  return (
    <Box
      sx={{
        "& .formBg": {
          border: `1px solid ${colors.grey[900]}`,
          background: `${colors.primary[400]}`,
        },
        "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
        "& .MuiGrid-root.Mui-heading h2": {
          color: `${colors.primary[200]} !important`,
        },
      }}
    >
      <Grid container>
        <Grid className="breadcrumb-section">
          <Grid className="breadcrumb-container">
            <Grid className="Mui-li">
              <nav className="Mui-nav" aria-label="breadcrumb">
                <ol className="">
                  <li className="MuiBreadcrumbs-li">
                    <h6 className="breadsub">Membership</h6>
                  </li>
                  <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                    /
                  </li>
                  <li className="MuiBreadcrumbs-li">
                    <h6>Members Data</h6>
                  </li>
                </ol>
              </nav>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={12} className="adduser au1 pt-2">
          <Controls.ActionButton onClick={AddContent}>
            Add Member
          </Controls.ActionButton>
          <Controls.ActionButton onClick={UploadExcel}>
            Add Excel
          </Controls.ActionButton>
        </Grid>
        <Grid item xs={12} className="formBg">
          <Container maxWidth="md" className="formClwidth">
            <div>
              <Controls.Grid
                columns={columns}
                data={sectionGrid}
                fileName={"Edit Content"}
              />
              {popup && (
                <Controls.Popup
                  title="Edit Member"
                  minHeight={100}
                  openPopup={popup}
                  setOpenPopup={handlePopup}
                >
                  <div>
                    <Formik
                      enableReinitialize
                      initialValues={{
                        ...(updatedValues || ADD_MEMBER_INITIAL_VALUES),
                      }}
                      validationSchema={ADD_MEMBER_VALIDATION_VALUES}
                      onSubmit={(values) => submitMemberValues(values)}
                    >
                      {({
                        values,
                        handleChange,
                        setFieldValue,
                        setFieldTouched,
                      }) => (
                        <Form>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="membershipNumber"
                                label={
                                  <span>
                                    Membership number <span className="asterisk">*</span>
                                  </span>
                                }
                                type="string"
                                autoFocus
                                inputProps={{ maxLength: 100 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="memberFullName"
                                label={
                                  <span>
                                    Member full name <span className="asterisk">*</span>
                                  </span>
                                }
                                type="string"
                                inputProps={{ maxLength: 100 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.AutoComplete
                                name="gender"
                                label={
                                  <span>
                                    Gender <span className="asterisk">*</span>
                                  </span>
                                }
                                type="string"
                                options={GenderDD}
                                value={genderData}
                                onChange={(event, value) => {
                                  if (value) {
                                    setFieldValue("gender", value?.value);
                                    setFieldValue("selectedDDgender", value);
                                    handleChange(event);
                                  }
                                  setGenderData(value);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              {isDropdown ? (
                                <Controls.AutoComplete
                                  name="familyName"
                                  label={
                                    <span>
                                      Select family name <span className="asterisk">*</span>
                                    </span>
                                  }
                                  options={familyNameDD}
                                  type="string"
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue(
                                        "familyNameId",
                                        value?.value
                                      );
                                      setFieldValue("familyName", value?.label);
                                      setFieldValue(
                                        "selectedDDfamilyName",
                                        value
                                      );
                                      handleChange(event);
                                    } else {
                                      setFieldValue(
                                        "familyName",
                                        event?.target?.value
                                      );
                                    }
                                  }}
                                />
                              ) : (
                                <Controls.Textfield
                                  name="familyName"
                                  label={
                                    <span>
                                      Family name <span className="asterisk">*</span>
                                    </span>
                                  }
                                  onChange={handleFieldChange(
                                    setFieldValue,
                                    "familyName"
                                  )}
                                />
                              )}
                            </Grid>
                            {!isDropdown && (
                              <Grid item xs={12} md={1}>
                                <SearchIcon
                                  className="btn-save"
                                  onClick={() =>
                                    handleSearch(values.familyName)
                                  }
                                />
                              </Grid>
                            )}
                            <Grid item xs={12} md={1}>
                              <AddIcon
                                className="btn-save"
                                onClick={() => {
                                  setIsDropdown(false);
                                  setFieldValue("familyName", "");
                                  setFieldValue("selectedDDfamilyName", null);
                                  handleData3();
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.AutoComplete
                                name="memberType"
                                value={memberTypeData}
                                label={
                                  <span>
                                    Member type <span className="asterisk">*</span>
                                  </span>
                                }
                                type="string"
                                options={MemberShipData}
                                onChange={(event, value) => {
                                  if (value) {
                                    setFieldValue("memberType", value?.value);
                                    setFieldValue(
                                      "selectedDDmemberType",
                                      value
                                    );
                                    handleChange(event);
                                  }
                                  setMemberTypeData(value);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="mobileNumber"
                                label={
                                  <span>
                                    Mobile no <span className="asterisk">*</span>
                                  </span>
                                }
                                type="string"
                                inputProps={{ maxLength: 10 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="emailID"
                                label="Email-id"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.DateTimePicker
                                name="dob"
                                label={
                                  <span>
                                    Date of birth <span className="asterisk">*</span>
                                  </span>
                                }
                                type="string"
                                disableFuture={true}
                                value={
                                  values?.dob
                                    ? dayjs(values?.dob, "DD/MM/YYYY")
                                    : null
                                }
                                onChange={(e) => {
                                  setFieldTouched("dob", true);
                                  setFieldValue(
                                    "dob",
                                    moment(new Date(e))?.format("DD/MM/YYYY")
                                  );
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="address"
                                label="Address"
                                type="string"
                                inputProps={{ maxLength: 150 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="state"
                                label="State"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="city"
                                label="City"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="country"
                                label="Country"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <Grid item xs={4} md={2} className="marginAuto">
                                <Controls.Button>Submit</Controls.Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </Controls.Popup>
              )}
              {popup1 && (
                <Controls.Popup
                  title="Add Member"
                  minHeight={100}
                  openPopup={popup1}
                  setOpenPopup={handlePopup1}
                >
                  <div>
                    <Formik
                      enableReinitialize
                      initialValues={ADD_MEMBER_INITIAL_VALUES}
                      validationSchema={ADD_MEMBER_VALIDATION_VALUES}
                      onSubmit={(values) => submitMemberValues(values)}
                    >
                      {({
                        values,
                        setFieldValue,
                        handleChange,
                        setFieldTouched,
                      }) => (
                        <Form>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="membershipNumber"
                                label="Membership number *"
                                type="string"
                                autoFocus
                                inputProps={{ maxLength: 100 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="memberFullName"
                                label={
                                  <span>
                                    Member full name <span className="asterisk">*</span>
                                  </span>
                                }
                                type="string"
                                inputProps={{ maxLength: 100 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.AutoComplete
                                name="gender"
                                label={
                                  <span>
                                    Gender <span className="asterisk">*</span>
                                  </span>
                                }
                                type="string"
                                options={GenderDD}
                                onChange={(event, value) => {
                                  if (value) {
                                    setFieldValue("gender", value?.value);
                                    setFieldValue("selectedDDgender", value);
                                  }
                                  handleChange(event);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              {isDropdown ? (
                                <Controls.AutoComplete
                                  name="familyName"
                                  label={
                                    <span>
                                      Select family name <span className="asterisk">*</span>
                                    </span>
                                  }
                                  options={familyNameDD}
                                  type="string"
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue("familyName", value?.value);
                                      setFieldValue(
                                        "selectedDDfamilyName",
                                        value
                                      );
                                    }
                                    handleChange(event);
                                  }}
                                />
                              ) : (
                                <Controls.Textfield
                                  name="familyName"
                                  label={
                                    <span>
                                      Family name <span className="asterisk">*</span>
                                    </span>
                                  }
                                  onChange={(event) => {
                                    setFieldValue(
                                      "familyName",
                                      event?.target?.value
                                    );
                                  }}
                                />
                              )}
                            </Grid>
                            {!isDropdown && (
                              <Grid item xs={12} md={1}>
                                <SearchIcon
                                  className="btn-save"
                                  onClick={() =>
                                    handleSearch(values.familyName)
                                  }
                                />
                              </Grid>
                            )}
                            <Grid item xs={12} md={1}>
                              <AddIcon
                                className="btn-save"
                                onClick={() =>
                                  handleAddFamilyName(setFieldValue)
                                }
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.AutoComplete
                                name="memberType"
                                label={
                                  <span>
                                    Member type <span className="asterisk">*</span>
                                  </span>
                                }
                                type="string"
                                options={MemberShipData}
                                onChange={(event, value) => {
                                  if (value) {
                                    setFieldValue("memberType", value?.value);
                                    setFieldValue("selectedMemberType", value);
                                  }
                                  handleChange(event);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="mobileNumber"
                                label={
                                  <span>
                                    Mobile no <span className="asterisk">*</span>
                                  </span>
                                }
                                type="string"
                                inputProps={{ maxLength: 10 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="emailID"
                                label="Email-id"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <Controls.DateTimePicker
                                name="dob"
                                label={
                                  <span>
                                    Date of birth <span className="asterisk">*</span>
                                  </span>
                                }
                                type="string"
                                disableFuture={true}
                                value={
                                  values?.dob
                                    ? dayjs(values?.dob, "DD/MM/YYYY")
                                    : null
                                }
                                onChange={(e) =>
                                  handleDobChange(
                                    setFieldTouched,
                                    setFieldValue,
                                    e
                                  )
                                }
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="address"
                                label="Address"
                                type="string"
                                inputProps={{ maxLength: 150 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="state"
                                label="State"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="city"
                                label="City"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="country"
                                label="Country"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <Grid item xs={4} md={2} className="marginAuto">
                                <Controls.Button>Submit</Controls.Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </Controls.Popup>
              )}
              {popup2 && (
                <Controls.Popup
                  title="Excel Data"
                  minHeight={100}
                  openPopup={popup2}
                  setOpenPopup={handlePopup2}
                >
                  <Formik
                    enableReinitialize
                    initialValues={EXCEL_INITIALFORM}
                    validationSchema={EXCEL_FORM_VALIDATION}
                    onSubmit={(values) => subExcelFile(values)}
                  >
                    {({ setFieldValue }) => (
                      <Form>
                        <Grid container spacing={2}>
                          <Grid item xs={6} md={4}>
                            <Controls.ActionButton
                              onClick={() => {
                                downloadExcel();
                              }}
                            >
                              <div>
                                <img
                                  src={EXCEL_ICON}
                                  width={35}
                                  alt="EXCEL_ICON"
                                />
                              </div>
                              <span className="button-four">
                                Donwload Sample
                              </span>
                            </Controls.ActionButton>
                          </Grid>

                          <Grid item xs={6} md={4}>
                            <Controls.ActionButton
                              onClick={() => {
                                downloadPDF({
                                  file: clientDataXLSX,
                                  showAlert,
                                  fileName: "Members_Data.xlsx",
                                });
                              }}
                            >
                              <div>
                                <img
                                  src={EXCEL_ICON}
                                  width={35}
                                  alt="EXCEL_ICON"
                                />
                              </div>
                              <span className="button-four">Donwload Data</span>
                            </Controls.ActionButton>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Grid className="col-lg-12 col-md-12">
                              <h3 className="">Data Upload</h3>
                              <Grid className="col-lg-8 col-md-8 l-float">
                                <input
                                  type="file"
                                  onChange={(e) => {
                                    saveFile(e, setFieldValue, "excelFile");
                                  }}
                                  className="fileupload ipfile"
                                />
                              </Grid>
                              <Grid item xs={6} md={6}>
                                <ErrorMessage name="excelFile">
                                  {(msg) => (
                                    <div
                                      style={{
                                        color: "#d32f2f",
                                        fontSize: "15px",
                                      }}
                                    >
                                      {msg}
                                    </div>
                                  )}
                                </ErrorMessage>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12}>
                            <Grid item xs={4} md={2} className="marginAuto">
                              <Controls.Button>Submit</Controls.Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Form>
                    )}
                  </Formik>
                </Controls.Popup>
              )}

              {popup3 && (
                <Controls.Popup
                  title="Add Family Name"
                  minHeight={100}
                  openPopup={popup3}
                  setOpenPopup={handlePopup3}
                >
                  <Formik
                    enableReinitialize
                    initialValues={FAMILYNAME_INITIALFORM}
                    validationSchema={FAMILY_NAME_VALIDATION}
                    onSubmit={(values) => subFamilyName(values)}
                  >
                    <Form>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} className="marginAuto1">
                          <Controls.Textfield
                            name="familyName"
                            label="Family name"
                            type="string"
                            inputProps={{ maxLength: 50 }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Grid item xs={4} md={2} className="marginAuto">
                            <Controls.Button>Submit</Controls.Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Form>
                  </Formik>
                </Controls.Popup>
              )}
            </div>
          </Container>
        </Grid>
        {alert.counter > 0 && (
          <CustomizedSnackbars
            status={alert.counter}
            msg={alert.msg}
            type={alert.type}
          />
        )}
      </Grid>
    </Box>
  );
};

export default MemberShip;
